export const votekickCatalog = {
  de: {
    name: "Votekick",
    description: "Community-Abstimmung für einen Timeout",
    howToPlayParticipation: "Im Chat mit 1 = Ja und 2 = Nein abstimmen.",
  },
  en: {
    name: "Votekick",
    description: "Community ballot for a timeout",
    howToPlayParticipation: "Vote in chat with 1 = yes and 2 = no.",
  },
} as const;
